import { render, staticRenderFns } from "./TgbContextMenu.vue?vue&type=template&id=6d6b7067"
import script from "./TgbContextMenu.vue?vue&type=script&lang=js"
export * from "./TgbContextMenu.vue?vue&type=script&lang=js"
import style0 from "./TgbContextMenu.vue?vue&type=style&index=0&id=6d6b7067&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports